// extracted by mini-css-extract-plugin
export default {"MetricsPageShortcuts-label":"MetricsPageShortcuts-label1kiTL5sCPO2o","MetricsPageShortcuts":"MetricsPageShortcuts3uPHtcVyHT0B"};